import { render, staticRenderFns } from "./sub-task.vue?vue&type=template&id=1f494550&scoped=true&"
import script from "./sub-task.vue?vue&type=script&lang=js&"
export * from "./sub-task.vue?vue&type=script&lang=js&"
import style0 from "./sub-task.vue?vue&type=style&index=0&id=1f494550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f494550",
  null
  
)

export default component.exports